import React from "react";

const Kotlin_Study_Plan = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Study Plan</h1>
      <p>Content for Kotlin Study Plan goes here.</p>
    </div>
  );
};

export default Kotlin_Study_Plan;
